// extracted by mini-css-extract-plugin
export var form = "_du-0";